import React, { createContext } from "react";

type SelectedGroupContextType = {
  selectedGroup: string | null;
  setSelectedGroup: React.Dispatch<React.SetStateAction<string | null>>;
};
const initialState = {
  selectedGroup: "None",
  setSelectedGroup: () => null,
};
const SelectedGroupContext = createContext<SelectedGroupContextType>(initialState);

export default SelectedGroupContext;
